var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronBackward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.320557 9C0.320557 9.3418 0.44751 9.63477 0.720947 9.88867L8.3186 17.3301C8.53345 17.5449 8.80688 17.6621 9.12915 17.6621C9.77368 17.6621 10.2913 17.1543 10.2913 16.5C10.2913 16.1777 10.1545 15.8945 9.9397 15.6699L3.09399 9L9.9397 2.33008C10.1545 2.10547 10.2913 1.8125 10.2913 1.5C10.2913 0.845703 9.77368 0.337891 9.12915 0.337891C8.80688 0.337891 8.53345 0.455078 8.3186 0.669922L0.720947 8.10156C0.44751 8.36523 0.320557 8.6582 0.320557 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBackward);
export default __webpack_public_path__ + "static/media/chevron-backward.49da2556920326e8150f04a246d197bc.svg";
export { ForwardRef as ReactComponent };